import React from 'react';

const PageTermsShutterstock = React.memo(function PageTermsShutterstock() {
    return (
        <section style={{ marginTop: '140px' }}>
            <div className="container">
                <div className="page" title="Page 2">
                    <div className="section">
                        <div className="layoutArea">
                            <div className="column">
                                <h3 className="mt-l5-48">
                                    Additional Terms for Use of Media Provided by Shutterstock, Inc.
                                </h3>
                                <div className="font-l5 font-l5--regular">
                                    Content is for digital use within Lumen5 only and may not be
                                    used for printing.
                                </div>
                                <div className="font-l5 font-l5--regular">
                                    You may not use the content as a trademark for a business.
                                </div>
                                <div className="font-l5 font-l5--regular">
                                    You may not portray a person in a way that may be offensive,
                                    including: in connection with adult-oriented services or ads for
                                    dating services; in connection with the promotion of tobacco
                                    products; in connection with political endorsements; with
                                    pornographic, defamatory, unlawful, offensive or immoral
                                    content; and as suffering from, or being treated for, a physical
                                    or mental ailment.
                                </div>
                                <div className="font-l5 font-l5--regular">
                                    You may only use the content in campaigns and content created on
                                    Lumen5 and not with other website or content services.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});

export default PageTermsShutterstock;
